import { Box } from "@theme-ui/components"
import React from "react"
import Nav from "./nav"
import MobileNav from "./mobileNav"

const Header = ({ theme, home = false }) => {
  return (
    <Box
      className="header_wrap"
      as="header"
      sx={{
        zIndex: 9,
        width: "100%",
        alignItems: "flex-start",
        usecustomtag: "true",
        marginTop: "0px",
        backgroundColor: "rgba(0,0,0,0)",
        position: ["fixed", "fixed", "relative"],
        display: "flex",
        flexWrap: "nowrap",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <Box
        sx={{
          display: ["none", "none", "block"],
        }}
      >
        <Nav theme={theme} home={home} />
      </Box>
      <Box
        sx={{
          width: "100%",
          display: ["block", "block", "none"],
        }}
      >
        <MobileNav theme={"light"} />
      </Box>
    </Box>
  )
}

export default Header
